import { pick } from "lodash-es";
import { SharedApiV2 } from "@capstone/mock-api";
import { SiteUpdate } from "./site-update.model";
import { Site } from "./site.model";

export class SiteHelpAssistSettingsUpdate {
  public constructor(private readonly update: SiteUpdate) {}

  public get base(): Site | null {
    return this.update.base;
  }

  public serialize(): SharedApiV2.PatchHelpAssistSiteDto {
    return pick(this.update.serialize(), [
      "autoApproveReservationsCutoff",
      "automaticAppointmentApproval",
      "helpAssistGeneralHelpTicketsAllowed",
      "helpAssistNotifyOnAmendmentRequested",
      "helpAssistNotifyOnAmendmentRequestedReceivers",
      "helpAssistNotifyOnApprovalRequested",
      "helpAssistNotifyOnApprovalRequestedReceivers",
      "helpAssistNotifyOnTicketApproved",
      "helpAssistNotifyOnTicketApprovedReceivers",
      "helpAssistNotifyOnTicketCreated",
      "helpAssistNotifyOnTicketCreatedReceivers",
      "helpAssistNotifyOnTicketDeclined",
      "helpAssistNotifyOnTicketDeclinedReceivers",
      "helpAssistNotifyOnTicketModified",
      "helpAssistNotifyOnTicketModifiedReceivers",
      "helpAssistTicketCategories",
      "helpAssistTicketResolutionTime",
      "helpAssistTicketsSchedulingAllowed",
    ]);
  }
}
